import React, { useEffect, useState } from "react";
import Select from "react-select";

import styles from "./Slct.module.css";

const Slct = props => {
  const {
    value,
    isMulti,
    formatGroupLabel,
    name,
    className,
    placeholder,
    options,
    closeMenuOnSelect,
    onChange,
    defaultValue,
    sortBy = "label",
    required,
    ...other
  } = props;

  const formatGroupCategories = categories => (
    <div style={{ opacity: 0.5 }}>
      <span>{categories.label}</span>
    </div>
  );

  let optionsSorted = [...options];

  if (sortBy) {
    if (optionsSorted.length > 2 || formatGroupLabel) {
      optionsSorted = optionsSorted.sort(function (a, b) {
        if ((!!a.value || formatGroupLabel) && a.value !== "<SELECT_ALL>") {
          if (typeof a[sortBy] === "number" && typeof a[sortBy] === "number") {
            return a[sortBy] > b[sortBy];
          } else {
            // return String(a[sortBy]).toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "") > String(b[sortBy]).toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            let _name_a = String(a[sortBy])
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            let _name_b = String(b[sortBy])
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "");
            return _name_a.localeCompare(_name_b);
          }
        }
      });
    }
  }

  const customStyles = {
    control: base => ({
      ...base,
      minHeight: "100%",
      boxShadow: "none",
      border: "none",
    }),
    dropdownIndicator: base => ({
      ...base,
      padding: 4,
    }),
    clearIndicator: base => ({
      ...base,
      padding: 4,
    }),
    multiValue: base => ({
      ...base,
      backgroundColor: "var(--color-primary-soft)",
    }),
    valueContainer: base => ({
      ...base,
      padding: "0px 6px",
    }),
    input: base => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    menu: base => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected ? "var(--color-primary)!important" : null,
      "&:hover": {
        backgroundColor: "var(--color-primary-soft)",
      },
    }),
  };

  const [valuesMulti, setvaluesMulti] = useState(value);

  const [isOpenMulti, setisOpenMulti] = useState(false);

  let initValue;
  if (defaultValue) {
    initValue = optionsSorted.filter(option => option.value === defaultValue);
  } else if (!placeholder) {
    initValue = optionsSorted[0];
  }

  useEffect(() => {
    if (isMulti) {
      if (value.length === 0) {
        setvaluesMulti([]);
      }
    }
  }, [value]);

  if (isMulti) {
    return (
      <div
        data-required={required}
        data-required-valid={required && value?.length > 0}
        data-select-container="true"
        onClick={e => {
          if (!e.target.id.includes("react-select") || !e.target.id.includes("option")) {
            setisOpenMulti(!isOpenMulti);
          }
        }}
      >
        <Select
          inputProps={{ autoComplete: "off", autoCorrect: "off", spellCheck: "off" }}
          styles={customStyles}
          name={name}
          closeMenuOnSelect={false}
          menuIsOpen={isOpenMulti}
          onBlur={() => {
            setisOpenMulti(false);
          }}
          className={`slct ${styles.Slct} ${styles.Slct_multi} ${className} ${
            !value ? "empty-select" : "filled-select"
          } slct`}
          isMulti={isMulti}
          options={optionsSorted}
          placeholder={placeholder}
          value={value}
          noOptionsMessage={() => "..."}
          isOptionDisabled={__option => __option.disabled}
          onChange={selected => {
            let selectedReturn;
            if (selected.some(e => e.value === "<SELECT_ALL>")) {
              selectedReturn = optionsSorted.filter(e => e.value !== "<SELECT_ALL>" && !e.disabled);
              setisOpenMulti(false);
            } else {
              selectedReturn = selected;
            }
            onChange && onChange(selectedReturn);
          }}
          {...other}
        />
      </div>
    );
  } else if (formatGroupLabel) {
    if (sortBy) {
      optionsSorted = optionsSorted
        .filter(e => e.options.length > 0)
        .map(e => {
          let categoryOptions = e.options.sort(function (a, b) {
            if (typeof a[sortBy] === "number" && typeof a[sortBy] === "number") {
              return a[sortBy] > b[sortBy];
            } else {
              return (
                String(a[sortBy])
                  .toUpperCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "") >
                String(b[sortBy])
                  .toUpperCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
            }
          });

          return {
            label: e.label,
            options: categoryOptions,
          };
        });
    }

    let allItems = [];
    optionsSorted.forEach(e => {
      e.options.forEach(e2 => {
        allItems.push({ value: e2.value, label: e2.label });
      });
    });

    optionsSorted = optionsSorted.sort(function (a, b) {
      if ((a.value || formatGroupLabel) && a.value !== "<SELECT_ALL>") {
        if (typeof a.value === "number" && typeof a.value === "number") {
          return a[sortBy] > b[sortBy];
        } else {
          return (
            String(a[sortBy])
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "") >
            String(b[sortBy])
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
        }
      }
    });

    return (
      <div data-required={required} data-required-valid={required && !!value}>
        <Select
          inputProps={{ autoComplete: "off", autoCorrect: "off", spellCheck: "off" }}
          value={allItems.filter(function (e) {
            return e.value == value;
          })}
          styles={customStyles}
          name={name}
          closeMenuOnSelect={closeMenuOnSelect}
          className={`slct ${styles.Slct} ${className} ${!value ? "empty-select" : "filled-select"}`}
          isMulti={isMulti}
          options={optionsSorted}
          placeholder={placeholder}
          onChange={onChange}
          noOptionsMessage={() => "..."}
          formatGroupLabel={formatGroupCategories}
          isOptionDisabled={__option => __option.disabled}
          {...other}
        />
      </div>
    );
  } else {
    return (
      <div data-required={required} data-required-valid={required && !!value}>
        <Select
          inputProps={{ autoComplete: "off", autoCorrect: "off", spellCheck: "off" }}
          value={optionsSorted.filter(function (e) {
            return e.value == value;
          })}
          styles={customStyles}
          name={name}
          closeMenuOnSelect={closeMenuOnSelect}
          className={`slct ${styles.Slct} ${className} ${!value ? "empty-select" : "filled-select"}`}
          isMulti={isMulti}
          options={optionsSorted}
          placeholder={placeholder}
          onChange={onChange}
          noOptionsMessage={() => "..."}
          isOptionDisabled={__option => __option.disabled}
          {...other}
        />
      </div>
    );
  }
};

export default Slct;
